/**
 * Register Module
 */
(function () {
	angular.module('app.register', ['ui.validate']);
})();